export default "https://assets.pclncdn.com/web/next-landing/6889411/_next/static/images/vegas-1f3103a4d1b1ef3e2dc86250021477cf.jpg";